import clsx from 'clsx'
import React from 'react'

import './Select.scss'

const Select = ({
   className,
   options,
   current,
   placeholder,
   onChange,
   isDarkTheme,
   ...props
}) => {
   return (
      <select
         className={clsx('Select', isDarkTheme && 'Select--dark', className)}
         value={current?.value || current?.title || placeholder}
         onChange={e => {
            const option = options.find(op => op.value === e.target.value)
            onChange(option)
         }}
         {...props}
      >
         {!!placeholder && <option disabled>{placeholder}</option>}
         {options.map(option => (
            <option value={option.value} key={option.value}>
               {option.title || option.value}
            </option>
         ))}
      </select>
   )
}

export default Select
